module.exports = __webpack_public_path__ + "img/01.58cf02b8.jpg";